import { Steps } from '../utils/agreements.util';

export const checkStepUpdate = (updatedSteps: string[], step: Steps) => {
	return updatedSteps.some((item) => item === step);
};
